import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  partnerLogosRoot: {
    background: theme.palette.background.default,
    paddingTop: '3.75rem',
    paddingBottom: '3.75rem',
    overflow: 'hidden',
  },
  headline: {
    color: theme.palette.secondary.light,
    textAlign: 'center',
  },
  headerLine: {
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: '2.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '2.87rem',
      paddingBottom: '1.25rem',
      alignItems: 'center',
    },
  },
  cardRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '250px',
    scale: '0.8',
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    minHeight: '60px',
  },
  image: {
    width: 'auto',
    maxWidth: '100%',
    height: '100%',
    maxHeight: '18.75rem',
    objectFit: 'cover',
  },
}))

export default useStyles
